const BASIC_FEATURES = [
  "Counters",
  "Risk Assessments",
  "Airplane Squawks Tracker",
] as const;

const ESSENTIAL_EXTRAS = [
  "Training",
  "Reports",
  "Maintenance Intelligence",
  "Engine Trending",
  "Weight and Balance",
  "Performance Calculator",
  "Document Storage",
] as const;

const PREMIUM_EXTRAS = [
  "Premium MFRAT+ and DRAT+",
  "Crew Chief Role",
] as const;

const ESSENTIAL_FEATURES = [...BASIC_FEATURES, ...ESSENTIAL_EXTRAS];
const PREMIUM_FEATURES = [...ESSENTIAL_FEATURES, ...PREMIUM_EXTRAS];

export {
  BASIC_FEATURES,
  ESSENTIAL_EXTRAS,
  ESSENTIAL_FEATURES,
  PREMIUM_EXTRAS,
  PREMIUM_FEATURES,
};
